// Copyright (c) 2016 Deere & Company

import {
    updateBeginDate,
    updateDemoRentalAccountsCriteria,
    updateDemoRentalAttributesCriteria,
    updateDemoRentalSelectAllAccountsCriteria,
    updateEndDate
} from './criteria';
import {createDemoRentalHistoryReport} from './report';
import {sharedActionCreators} from '../../shared/action-creators';
import {updateDemoRentalBranches} from './branches';
import {updateDemoRentalFactoryCodes} from './factory-codes';
import {updateDemoRentalStatuses} from './statuses';

export default {
    createDemoRentalHistoryReport,
    updateBeginDate,
    updateDemoRentalAccountsCriteria,
    updateDemoRentalAttributesCriteria,
    updateDemoRentalBranches,
    updateDemoRentalFactoryCodes,
    updateDemoRentalSelectAllAccountsCriteria,
    updateDemoRentalStatuses,
    updateEndDate,
    ...sharedActionCreators
};



// WEBPACK FOOTER //
// ./src/reports/demo-rental-history/action-creators/index.js